<template>
    <form @submit.prevent="onHandleStoreMonthlyPayments" data-vv-scope="licenses-monthly-payments"
        class="shadow-sm p-3 rounded">

        <div class="w-100 d-flex justify-content-between align-items-center">
            <strong :class="{ 'text-xl': isShowFormMonthlyPayment, 'text-xs': !isShowFormMonthlyPayment }">Registrar pagos</strong>
            <div role="button" @click="showForm" class="py-2 px-3 bg-gray-100 btn">
                <i class="fa" :class="{ 'fa-arrow-down': !isShowFormMonthlyPayment, 'fa-arrow-up': isShowFormMonthlyPayment }" />
                <span class="ml-2">{{ isShowFormMonthlyPayment ? 'Ocultar formulario' : 'Mostrar formulario' }}</span>
            </div>
        </div>

        <b-row v-if="isShowFormMonthlyPayment" class="mt-4">
            <!-- Fechas -->
            <b-col md="4" lg="4" sm="12">
                <b-form-group>
                    <label for="monthly-payments-date">Fechas</label>
                    <el-date-picker v-model="monthlyPayment.dates" id="monthly-payments-date" name="monthly-payments-date"
                        type="daterange" size="small" class="w-100" range-separator="-" start-placeholder="Fecha de inicio"
                        end-placeholder="Fecha de fin" :picker-options="optionsFormDates" format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd" data-vv-as=" " v-validate="'required'" />
                    <div class="text-danger span-error small" v-text="errors.first('licenses-monthly-payments.monthly-payments-date')" />
                </b-form-group>
            </b-col>

            <!-- Cantidad de horas -->
            <b-col md="3" lg="3" sm="12">
                <b-form-group>
                    <label for="monthly-payments-quantity-hours" class="w-100">
                        Cantidad de horas
                    </label>
                    <b-form-input type="number" id="monthly-payments-quantity-hours" name="monthly-payments-quantity-hours"
                        v-model="monthlyPayment.quantity_hours" data-vv-as=" " v-validate="{
                            required: true,
                            numeric: true,
                            min_value: 1
                        }" />
                    <div class="text-danger span-error small" v-text="errors.first('licenses-monthly-payments.monthly-payments-quantity-hours')" />
                </b-form-group>
            </b-col>

            <!-- Descripción -->
            <b-col cols="12">
                <b-form-group>
                    <label for="monthly-payments-description" class="w-100">Descripción</label>
                    <b-form-textarea id="monthly-payments-description" name="monthly-payments-description" v-model="monthlyPayment.description"
                        data-vv-as=" " v-validate="'min:3|max:255|required'" />
                        <div class="d-flex justify-content-between alig-items-center">
                            <div class="text-danger span-error small" v-text="errors.first('licenses-monthly-payments.monthly-payments-description')" />
                            <small :class="{ 'text-danger': getQuantityTextAreaLenght > 255, 'text-success': getQuantityTextAreaLenght <= 255 }">
                                {{ getQuantityTextAreaLenght }} caracteres de 255 permitidos.
                            </small>
                        </div>
                </b-form-group>
            </b-col>
        </b-row>

        <!-- Botones -->
        <div v-if="isShowFormMonthlyPayment" class="d-flex justify-content-end align-items-center">
            <button type="button" class="btn btn-light" @click="onHandleCancelStoreMonthlyPayments">
                <i class="fa fa-trash mr-1 text-danger" />
                <span class="text-danger">Cancelar</span>
            </button>
            <b-button type="button" variant="primary" @click="onHandleStoreMonthlyPayments" class="ml-2">
                <i class="fa mr-1" :class="{ 
                    'fa-save': monthlyPayment.action === 'CREATE',
                    'fa-edit': monthlyPayment.action === 'UPDATE'
                }" /> 
                {{ monthlyPayment.action === 'CREATE' ? 'Crear pago' : 'Guardar cambios' }}
            </b-button>
        </div>

    </form>
</template>

<script>

// Generales
import { mapState, mapActions, mapMutations  } from 'vuex';

export default {
    name: 'montjly-payments-update-or-create',
    data() {
        return {
            // configuracion de opciones predeterminadas para el formulario de fechas
            optionsFormDates: {
                shortcuts: [
                    {
                        text: 'Último mes',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                ]
            }
        }
    },
    computed: {
        // Pagos mensuales de las licencias.
        ...mapState('monthlyPayments', [
            'monthlyPayment',
            'isShowFormMonthlyPayment',
            'filter'
        ]),
        // Empresas
        ...mapState('empresa', [
            'selectedEmpresa',
        ]),
        // Licencias.
        ...mapState('licencias', [
            'licencia',
        ]),
        /**
         * Obtener la cantidad de caracteres del textarea.
         * 
         * @author Fernando Claros
         */
        getQuantityTextAreaLenght() {
            return typeof this.monthlyPayment.description === 'string' ? this.monthlyPayment.description.length : 0;
        }
    },
    methods: {
         // Pagos mensuales de las licencias
        ...mapActions('monthlyPayments', [
            'storeMonthlyPayment',
            'updateMonthlyPayment'
        ]),
        ...mapMutations('monthlyPayments', [
            'setDefaultMonthlyPayment',
            'setIsShowFormMonthlyPayment'
        ]),
        /**
         * Cancelar y limpiar formulario.
         * 
         * @author Fernando Claros
         */
        onHandleCancelStoreMonthlyPayments() {
            this.setDefaultMonthlyPayment();
        },
        /**
         * Crear o actualizar pagos mensuales de las licencias.
         * 
         * @author Fernando Claros
         */
        async onHandleStoreMonthlyPayments() {
            await this.$validator.validateAll('licenses-monthly-payments')
                .then(async isValid => {
                    if (!isValid) return;

                    let date_start = ('dates' in this.monthlyPayment && this.monthlyPayment.dates.length > 0) ? this.monthlyPayment.dates[0] : '';
                    let date_end = ('dates' in this.monthlyPayment && this.monthlyPayment.dates.length > 0) ? this.monthlyPayment.dates[1] : '';

                    const payload = {
                        ...this.monthlyPayment,
                        date_start,
                        date_end,
                        slq_company_id: this.selectedEmpresa.id,
                        slq_license_id: this.licencia.id,
                        is_active: this.monthlyPayment.is_active ? 1 : 0,
                        page: this.filter.page,
                        sortBy: this.filter.sortBy,
                        sort: this.filter.sort,
                        per_page: this.filter.per_page
                    }

                    if (this.monthlyPayment.action === 'CREATE') this.storeMonthlyPayment(payload)
                    else this.updateMonthlyPayment(payload)
                })
        },
        /**
         * Mostrar ocultar el contenido del formulario.
         * 
         * @author Fernando Claros
         */
        showForm() {
            this.setDefaultMonthlyPayment();
            this.setIsShowFormMonthlyPayment();
        }
    }
};
</script>

<style scope>
.text-xl{
    font-size: 20pt;
}
.text-xs{
    font-size: 12pt;
}
.btn:hover{
    cursor: pointer;
}
</style>
